import s from './GigAssChatForm.module.sass'
import { StarIcon } from '../../ui/StarIcon'
import { useTextareaHeight } from '../../hooks/useTextareaHeight'

import { FC, useRef } from 'react'
import type { FormEvent, KeyboardEvent, MouseEvent, FocusEvent } from 'react'

type Props = {
  message: string
  state: string
  onMessageChange: (value: string) => void
  onSubmit: (e: FormEvent) => void
  onKeyPress: (e: KeyboardEvent<HTMLTextAreaElement>) => void
  onBlur: (e: FocusEvent<HTMLTextAreaElement>) => void
  messagesLength: number
}

/**
 * @function ChatForm - инпут-форма для отправки сообщений
 */
const GigAssChatForm: FC<Props> = (props) => {
  const { message, state, onMessageChange, onSubmit, onKeyPress, onBlur, messagesLength } = props

  const textareaRef = useRef<HTMLTextAreaElement>(null)

  useTextareaHeight({
    textareaRef: textareaRef,
    value: message,
    maxLines: 3,
    state,
  })

  const focusTextarea = (e: MouseEvent<HTMLFormElement> | FocusEvent<HTMLFormElement>) => {
    e.preventDefault()
    textareaRef.current?.focus()
  }

  return (
    <form
      className={s.form}
      data-is-empty-list={messagesLength === 0}
      onSubmit={onSubmit}
      onClick={focusTextarea}
      onFocus={focusTextarea}
      tabIndex={0}>
      <div className={s.starIcon}>
        <StarIcon />
      </div>

      <textarea
        className={s.formInput}
        value={message}
        onChange={(e) => onMessageChange(e.target.value)}
        onKeyPress={onKeyPress}
        onBlur={onBlur}
        placeholder='Спросите что-нибудь...'
        disabled={state === 'sending' || state === 'waiting'}
        data-key='form-input'
        ref={textareaRef}
      />

      <button
        className={`${s.formButton} ${s.isHidden}`}
        type='submit'
        disabled={!message.trim() || state === 'sending' || state === 'waiting'}>
        Отправить
      </button>
    </form>
  )
}

export default GigAssChatForm
